document.addEventListener("DOMContentLoaded", () => {
  const modal = document.getElementById("ls-modal");
  const slider = modal.querySelector(".ls-slider");
  const title = modal.querySelector("#ls-title");

  document.querySelectorAll(".ls-card").forEach(card => {
    card.addEventListener("click", async () => {
      const handle = card.dataset.productHandle;

      const res = await fetch(`/products/${handle}.js`);
      const product = await res.json();

      title.innerText = product.title;
      slider.innerHTML = "";

      product.images.slice(0, 4).forEach(img => {
        const image = document.createElement("img");
        image.src = img;
        slider.appendChild(image);
      });

      modal.classList.add("active");
    });
  });

  modal.querySelector(".ls-close").onclick = () =>
    modal.classList.remove("active");

  modal.querySelector(".ls-modal-overlay").onclick = () =>
    modal.classList.remove("active");
});

document.addEventListener("DOMContentLoaded", function () {
  new Swiper(".launching-swiper", {
    slidesPerView: 1,
    spaceBetween: 16,
    grabCursor: true,
    loop: false,

    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },

    breakpoints: {
      640: {
        slidesPerView: 2
      },
      768: {
        slidesPerView: 3
      },
      1024: {
        slidesPerView: 5
      }
    }
  });
});
